import { render } from "./user_register.vue?vue&type=template&id=f5757e06&scoped=true"
import script from "./user_register.vue?vue&type=script&lang=js"
export * from "./user_register.vue?vue&type=script&lang=js"

import "./user_register.vue?vue&type=style&index=0&id=f5757e06&lang=scss"
import "./user_register.vue?vue&type=style&index=1&id=f5757e06&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5757e06"]])

export default __exports__